import useMutationApi from 'src/api/useMutationApi';
import { DivisionDTO } from '@erp/shared-types';

interface CreateDivisionRequest {
  name: string;
  metadata?: Record<string, unknown> | null;
}

interface CreateDivisionResponse {
  division: DivisionDTO;
}

const useCreateDivision = (onSuccess?: (division: DivisionDTO) => void) => {
  return useMutationApi<CreateDivisionRequest, CreateDivisionResponse>({
    endpoint: 'organization/divisions',
    method: 'POST',
    options: {
      onSuccess: onSuccess
        ? (res) => {
            onSuccess(res.data.division);
          }
        : undefined,
    },
  });
};

export default useCreateDivision;
